'use client';

import { BlogCard } from '@/components/BlogCard';
import { CategoryTabs } from '@/components/CategoryTabs';
import { getSortedBlogCategories } from '@/content/blog-categories';
import type { PostMeta } from '@/lib/blog';
import { useState } from 'react';

interface BlogExplorerProps {
  posts: PostMeta[];
}

export function BlogExplorer({ posts }: BlogExplorerProps) {
  const [activeId, setActiveId] = useState('all');

  const items = getSortedBlogCategories().map((c) => ({
    id: c.id,
    label: c.label,
    count: posts.filter((p) => p.category === c.id).length,
  }));

  const filtered = activeId === 'all' ? posts : posts.filter((p) => p.category === activeId);

  return (
    <div>
      <CategoryTabs
        items={items}
        activeId={activeId}
        onSelect={setActiveId}
        totalCount={posts.length}
      />
      <div className="mt-6 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {filtered.map((post) => (
          <BlogCard key={post.slug} post={post} />
        ))}
      </div>
      {filtered.length === 0 && (
        <p className="mt-8 text-center text-sm text-muted-foreground">
          No posts in this category yet.
        </p>
      )}
    </div>
  );
}
